
<template>
  <div>
    <Spiner :class="statusData.spinnerStatus ? '' : 'display_none'"/>

    <!-- 검색 데이터 모달로 만들 부분  -->
    <div
      class="admin_addModalBox"
      :class="statusData.modalStatus ? '' : 'display_none'"
    >
      <div class="admin_addModalBox_dim">
      </div>
      <div class="admin_addModalBox_inner">
        <div class="admin_addModalBox_tit">
          <p>회원검색</p>
          <button
            class="admin_addModalBox_BtnClose"
            v-on:click="modal_close"
          >
          </button>
        </div>

        <div class="admin_addModalBox_search">
          <input
            type='text'
            id='search_data'
            name='search_data'
            maxLength="30"
            placeholder="회원명을 입력해주세요."
            v-model="statusData.searchInputData"
            @keyup.enter="customer_search"
          />
          <button
            v-on:click="customer_search"
          >
            검색
          </button>
        </div>

        <div class="admin_addModalBox_result">
          <!-- 검색한 데이터가 없을 시  -->
          <div
            class="admin_addModalBox_result_noData"
            v-if="this.statusData.searchData.length === 0"
            >
            <p>회원을 검색해주세요.</p>
          </div>

          <!-- 검색한 데이터가 있을시 시  -->
          <div
            class="admin_addModalBox_result_Data"
            v-else
            >
            <ul class="admin_addModalBox_result_Data_ulTit">
              <li>회원명</li>
              <li>전화번호</li>
              <li>이메일</li>
              <li>등록하기</li>
            </ul>

            <ul class="admin_addModalBox_result_Data_ulInfo"
              v-for="item in statusData.searchData"
              :key="item.customer_ID"
              >
              <li class="admin_addModalBox_result_Data_li_text">{{item.customer_name}}</li>
              <li class="admin_addModalBox_result_Data_li_text">{{item.customer_phone_number}}</li>
              <li class="admin_addModalBox_result_Data_li_text">{{item.customer_email}}</li>
              <li class="admin_addModalBox_result_Data_li_btn">
                <button
                  v-on:click="add_customer(
                    item.customer_ID,
                    item.customer_name,
                  )"
                >
                  등록
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div> <!-- 검색 데이터 모달로 만들 부분  -->

    <div style="display:flex">
      <AdminHeader v-bind:menu_id="'4-2'"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>
            회원 관리 - 쿠폰 {{ $route.query.coupon_ID === undefined ? '등록' : '수정' }}
          </p>
          <div class="Admin_PageHeader_btn">
            <button class="Admin_PageHeader_btn01" v-on:click="check_form">
              {{ $route.query.coupon_ID === undefined ? '등록' : '수정' }}
            </button>
          </div>
        </div>

        <div class="Admin_PageDetail">

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='customer_name'>회원명<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id='customer_name'
                placeholder = "클릭 후 회원을 검색해주세요."
                v-model="statusData.customerName"
                @click="cell_click"
                readonly
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.customerNameError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='coupon_name'>쿠폰명<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'coupon_name'
                maxLength="50"
                placeholder = "쿠폰명을 입력해 주세요."
                v-model="formData.couponName"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.couponNameError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap" v-if="$route.query.coupon_ID !== undefined">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='coupon_type'>쿠폰타입</label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id='coupon_type'
                v-model="statusData.couponType"
                readonly
              />
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='coupon_discount_type'>할인타입<span class="pointTextRed"> * </span></label>
              <select
                class="Admin_PageDetail_inputSelect"
                id="coupon_discount_type"
                v-model="formData.couponDiscountType"
              >
                <option value='0'>퍼센트</option>
                <option value='1'>고정</option>
              </select>
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='coupon_discount_value'>할인값<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'coupon_discount_value'
                maxLength="13"
                placeholder = "할인값을 입력해 주세요."
                v-model="formData.couponDiscountValue"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.couponDiscountError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='coupon_min_order_amount'>최소주문금액<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id = 'coupon_min_order_amount'
                maxLength="13"
                placeholder = "최소주문금액을 입력해 주세요."
                v-model="formData.couponMinOrderAmount"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.couponMinOrderAmountError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='coupon_valid_from'>쿠폰 시작일<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='date'
                id = 'coupon_valid_from'
                maxLength="13"
                max="2999-12-30"
                v-model="formData.couponValidFrom"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.couponValidFromError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='coupon_valid_until'>쿠폰 종료일<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                type='date'
                id = 'coupon_valid_until'
                maxLength="13"
                max="2999-12-30"
                v-model="formData.couponValidUntil"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.couponValidUntilError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap" v-if="$route.query.coupon_ID !== undefined">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='coupon_issued_at'>발급일자</label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id='coupon_issued_at'
                v-model="statusData.couponIssuedAt"
                readonly
              />
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap" v-if="$route.query.coupon_ID !== undefined">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='coupon_is_used'>사용여부</label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id='coupon_is_used'
                v-model="statusData.couponIsSsed"
                readonly
              />
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap" v-if="$route.query.coupon_ID !== undefined">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='coupon_used_at'>사용일자</label>
              <input
                class="Admin_PageDetail_inputText"
                type='text'
                id='coupon_used_at'
                v-model="statusData.couponUsedAt"
                readonly
              />
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import { ref } from 'vue'
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'
import Spiner from '../../Homepage/Section/Spiner.vue'
import {
  get_customer_search,
  get_coupon_one,
  insert_coupon,
  update_coupon
} from '../../ETC/Axios.vue'
import {
  removeWhitespace
} from '../../ETC/Validation.vue'

export default {
  name: 'AdminCustomerManagementAdd',
  components: {
    AdminHeader: AdminHeader,
    AdminFooter: AdminFooter,
    Spiner: Spiner
  },
  setup () {
    return {
      formData: ref({
        customerIDUseCoupon: '0',
        couponName: '',
        couponDiscountType: '0',
        couponDiscountValue: '0',
        couponMinOrderAmount: '0',
        couponValidFrom: '',
        couponValidUntil: ''
      }),
      errorData: ref({
        customerNameError: '',
        couponNameError: '',
        couponDiscountError: '',
        couponMinOrderAmountError: '',
        couponValidFromError: '',
        couponValidUntilError: ''
      }),
      statusData: ref({
        modalStatus: false,
        searchData: [],
        searchInputData: '',
        searchDataText: '회원을 검색해주세요.',
        customerName: '',
        couponType: '',
        couponIssuedAt: '',
        couponIsSsed: '',
        couponUsedAt: ''
      })
    }
  },
  watch: {
    'formData.couponDiscountValue': function (value) {
      const cleanedValue = removeWhitespace(value.replace(/[^0-9]/g, '')).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      this.formData.couponDiscountValue = cleanedValue
    },
    'formData.couponMinOrderAmount': function (value) {
      const cleanedValue = removeWhitespace(value.replace(/[^0-9]/g, '')).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      this.formData.couponMinOrderAmount = cleanedValue
    }
  },
  methods: {
    cell_click: function (e, cell) {
      this.statusData.modalStatus = true
    },
    modal_close: function () {
      this.statusData.modalStatus = false
    },
    customer_search: function () {
      if (this.statusData.searchInputData.length < 1) {
        alert('최소 1자이상 입력해주세요.')
      } else {
        get_customer_search(this.statusData.searchInputData).then(result => {
          if (result.length === 0) {
            this.statusData.searchData = []
            this.statusData.searchDataText = '검색에 회원이 없습니다.'
          } else {
            this.statusData.searchData = result
          }
        })
      }
    },
    add_customer: function (
      customer_ID,
      customer_name
    ) {
      this.formData.customerIDUseCoupon = customer_ID
      this.statusData.customerName = customer_name
      this.statusData.modalStatus = false
    },
    check_form: function () {
      let isValid = true
      const e = this.errorData

      if (!this.formData.customerIDUseCoupon) {
        e.customerNameError = '회원 선택은 필수입니다.'
        isValid = false
      } else {
        e.customerNameError = ''
      }

      if (!this.formData.couponName) {
        e.couponNameError = '쿠폰명을 입력해주세요.'
        isValid = false
      } else {
        e.couponNameError = ''
      }

      if (!this.formData.couponDiscountValue || this.formData.couponDiscountValue === '0') {
        e.couponDiscountError = '할인값을 입력해주세요.'
        isValid = false
      } else {
        const numericValue = parseInt(this.formData.couponDiscountValue.replace(/,/g, ''))
        if (this.formData.couponDiscountType === '0' && (numericValue <= 0 || numericValue >= 100)) {
          e.couponDiscountError = '퍼센트 할인은 1 이상 99 이하로 입력해주세요.'
          isValid = false
        } else {
          e.couponDiscountError = ''
        }
      }

      if (!this.formData.couponMinOrderAmount) {
        e.couponMinOrderAmountError = '최소주문금액을 입력해주세요.'
        isValid = false
      } else {
        e.couponMinOrderAmountError = ''
      }

      if (!this.formData.couponValidFrom) {
        e.couponValidFromError = '쿠폰 시작일을 선택해주세요.'
        isValid = false
      } else {
        e.couponValidFromError = ''
      }

      if (!this.formData.couponValidUntil) {
        e.couponValidUntilError = '쿠폰 종료일을 선택해주세요.'
        isValid = false
      } else {
        e.couponValidUntilError = ''
      }

      if (!isValid) {
        alert('필수 입력값을 확인해주세요.')
        return
      }

      this.statusData.spinnerStatus = true

      const payload = {
        customerIDUseCoupon: this.formData.customerIDUseCoupon,
        couponName: this.formData.couponName,
        couponDiscountType: this.formData.couponDiscountType,
        couponDiscountValue: this.formData.couponDiscountValue.replace(/,/g, ''),
        couponMinOrderAmount: this.formData.couponMinOrderAmount.replace(/,/g, ''),
        couponValidFrom: this.formData.couponValidFrom,
        couponValidUntil: this.formData.couponValidUntil
      }

      if (this.$route.query.coupon_ID === undefined) {
        insert_coupon(payload).then(() => {
          this.statusData.spinnerStatus = false
          alert('쿠폰 등록이 완료되었습니다.')
          window.location.href = '/AdminCouponManagement'
        })
      } else {
        update_coupon(this.$route.query.coupon_ID, payload).then(() => {
          this.statusData.spinnerStatus = false
          alert('수정이 완료되었습니다.')
          window.location.href = '/AdminCouponManagement'
        })
      }
    }

  },
  mounted () {
    if (this.$route.query.coupon_ID !== undefined) {
      get_coupon_one(this.$route.query.coupon_ID).then((result) => {
        const item = result[0]
        this.formData.customerIDUseCoupon = item.customer_ID_use_coupon.toString()
        this.statusData.customerName = item.customer_name
        this.formData.couponName = item.coupon_name
        this.statusData.couponType = item.coupon_type
        this.formData.couponDiscountType = item.coupon_discount_type.toString()
        this.formData.couponDiscountValue = item.coupon_discount_value.toLocaleString()
        this.formData.couponMinOrderAmount = item.coupon_min_order_amount.toLocaleString()
        this.formData.couponValidFrom = item.coupon_valid_from
        this.formData.couponValidUntil = item.coupon_valid_until
        this.statusData.couponIssuedAt = item.coupon_issued_at
        this.statusData.couponIsSsed = item.coupon_is_used
        this.statusData.couponUsedAt = item.coupon_used_at
      })
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/Admin/CustomerManagement/AdminCouponManagementAdd.vue